import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 8px;
  .toggle-content.expanded {
    height: calc-size(auto, size);
  }
  .toggle-content {
    transition: height 0.4s ease-in-out;
    overflow: hidden;
    height: 0;
  }
`;

const Toggle = styled.div<{ height: string; alwaysOpen?: boolean }>`
  width: 100%;
  margin: 0;
  min-height: 60px;
  height: auto;
  cursor: ${(prop) => (prop.alwaysOpen ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  background-color: #fff;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: ${(prop) => (prop.alwaysOpen ? '0px' : '8px')};
  border-top-left-radius: 8px;
  &::before {
    content: ' ';
    min-width: 4px;
    width: 4px;
    background-color: ${(prop) => prop.color};
    min-height: 60px;
    height: ${(prop) => prop.height};

    display: flex;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
    @media (min-width: 465px) {
      height: 60px;
    }
  }
  &.toggleOpen::before {
    border-bottom-left-radius: 0px;
  }
  &.toggleOpen {
    border-bottom-right-radius: 0px;
  }
  div.toggleHeader {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 8px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #161d1f;
    margin-left: 8px;
    font-weight: 400;
  }
  p.expanded {
    font-weight: 700;
  }
  p.ok {
    color: var(--interaction-primary);
    font-weight: 700;
  }
  span {
    margin-right: 4px;
  }
  button {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
  }

  ${(prop) =>
    prop.alwaysOpen &&
    `
    cc-icon {
      display: none;
    }
    & button {
      display: none;
    }
  `}

  cc-icon {
    color: var(--text-primary);
  }
  & button {
    &:hover {
      background: #e2dffd;
    }
    &:focus-visible {
      background: #5b36f2;
      outline: white solid 2px;
      box-shadow: 0 0 0 4px #5b36f2;
      cc-icon {
        color: #fff;
      }
    }
    &:active {
      background: #c6c0fc;
      outline: none;
      box-shadow: none;

      cc-icon {
        color: var(--text-primary);
      }
    }
  }
`;

const Text = styled.p`
  padding: 1rem;
  margin: 0;
`;

const ContainerCollapse = styled.div`
  width: 100%;
  background-color: #fff;
  // padding: 8px;
  display: flex;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;

  > div {
    width: 100%;
  }

  &::before {
    content: ' ';
    min-width: 4px;
    width: 4px;
    background-color: ${(prop) => prop.color};
    height: auto;
    display: flex;
    border-bottom-left-radius: 8px;
  }
`;

export const HeaderCaption = styled.div`
  padding-left: 8px;
`;

export const HeaderTitle = styled.h4<{
  variant: string;
  active: boolean;
}>`
  font-size: 16px;
  font-weight: ${(props) => (props.active ? '700' : '400')};
  font-family: Lato;
  line-height: 24px;
  color: ${(props) => (props.variant === 'is-ok' ? '#5b36f2' : '#161d1f')};
`;

export const HeaderSubtitle = styled.h5<{
  if?: string;
}>`
  display: ${(props) => (props.if ? 'block' : 'none')};
  font-size: 14px;
  font-weight: 400;
  color: #5b36f2;
`;

export { Container, ContainerCollapse, Toggle, Text };
